
export default function (Component) {
  Component.options.__source = "src/layout/no-header/components/menu-side/index.vue"
}
